<template>
  <div class="groupItem">
    <ul>
      <li><b>Group Leader</b> {{ groupLeader }}</li>
      <li><b>Group Name: </b> {{ groupName }}</li>
      <div v-if="members">
        <member-group
          :groupId="id"
          v-for="member in members"
          :key="member.id"
          :id="member.id"
          :firstName="member.firstName"
          :lastName="member.lastName"
        >
        </member-group>
      </div>

      <note-item
        v-for="note in group.notes"
        :key="note.id"
        :parentId="id"
        :noteId="note.id"
        :note="note.note"
      >
      </note-item>
      <br />
      <div class="note">
        <textarea v-model="note"></textarea>
        <button class="btn" @click="addNote">Add a Note</button>
      </div>
      <div>
        <button class="btn memRemoveBtn" @click="removeGroup">
          Remove Group
        </button>
      </div>
    </ul>
  </div>
</template>

<script>  
 import MemberGroup from '../components/MemberGroup'


    export default {
     components: {
         MemberGroup: MemberGroup
         
       },
         props: ['id', 'groupLeader', 'groupName', 'members' ,'notes' ],
         data () {
            return {
              note: ""
            }
          },
          
          computed: {
            group() {
            return this.$store.getters['groups/groups'].find(m => m.id === this.id);
           }
          },


        methods: {
        
        async getGroups() {
           await this.$store.dispatch('groups/fetchGroups')
        },

        addNote() {
          this.$store.dispatch('groups/addNote', {id: this.id,  note: this.note})
        },

        removeGroup() {
          this.$store.dispatch('groups/removeGroup', {id: this.id})
        },

        removemember(){
          this.$store.dispatch('groups/removeFromGroup', {id: this.id, member: this.memberId })
          this.getGroups()
        },
      },

  
    }
</script>

<style scoped>
ul {
  text-align: left;
}

li {
  list-style: none;
}

.groupItem {
  border-bottom: 1px solid black;
  margin-bottom: 1rem;
  border-radius: 12px;
}

.btn {
  margin-top: 1rem;
  background-color: cadetblue;
  /* color: #9a3f3f; */
  color: white;
  padding: 0.5rem;
  border: none;
  border-radius: 0.3rem;
  width: 11em;
  font-size: 1em;
  cursor: pointer;
}

.memRemoveBtn {
  background-color: #d29b9b;
}

.note {
  justify-content: space-evenly;
  display: flex;
  flex-direction: column;

  width: 50%;
}
</style>